export var OOS_RECOVERY_OPTIONS = {
    STORE_PICKUP_OPTION: 'STORE_PICKUP_OPTION',
    STH_DELIVERY_OPTION: 'STH_DELIVERY_OPTION',
};
export var FLOW_TYPES;
(function (FLOW_TYPES) {
    FLOW_TYPES["BOPIS_OOS_RECOVERY"] = "BOPIS_OOS_RECOVERY";
    FLOW_TYPES["EDIT_PICKUP_LOCATION"] = "EDIT_PICKUP_LOCATION";
    FLOW_TYPES["EDIT_DELIVERY_ADDRESS"] = "EDIT_DELIVERY_ADDRESS";
})(FLOW_TYPES || (FLOW_TYPES = {}));
